import { Overview } from 'api/Transactions/types';

export const OVERVIEW_INITIAL_STATE: Overview = {
  totalTestKitRequestDirect: 0,
  totalTestKitRequestReturn: 0,
  totalTestKitDelivered: 0,
  kitInTransit: 0,
};
